import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import {
  appContainerWithMenuSlice,
  AppContainerWithMenuState,
  hideDashboardMenuAction,
  setIsAutoExpandedAction,
  setIsDashboardMenuVisibleAction,
  setIsFullMenuVisibleAction,
  showDashboardMenuAction,
  toggleIsFullMenuVisibleAction,
} from './appContainerWithMenu.slice';

export const appContainerWithMenuMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const appContainerWithMenuState = api.getState()?.[appContainerWithMenuSlice.name];

  if (appContainerWithMenuState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    appContainerMiddlewares[action?.type]?.(appContainerWithMenuState);
  }

  return result;
};

const appContainerMiddlewares = {
  [setIsAutoExpandedAction.type]: (state: AppContainerWithMenuState) => {
    appStorage.setAppMenuIsAutoExpanded(state.isAutoExpanded);
  },

  [setIsFullMenuVisibleAction.type]: (state: AppContainerWithMenuState) => {
    appStorage.setAppMenuIsFullMenuVisible(state.isFullMenuVisible);
  },

  [toggleIsFullMenuVisibleAction.type]: (state: AppContainerWithMenuState) => {
    appStorage.setAppMenuIsFullMenuVisible(state.isFullMenuVisible);
  },

  [setIsDashboardMenuVisibleAction.type]: (state: AppContainerWithMenuState) => {
    appStorage.setAppMenuIsDashboardMenuVisible(state.isDashboardMenuVisible);
  },

  [showDashboardMenuAction.type]: (state: AppContainerWithMenuState) => {
    appStorage.setAppMenuIsDashboardMenuVisible(state.isDashboardMenuVisible);
    appStorage.setAppMenuIsFullMenuVisible(state.isFullMenuVisible);
  },

  [hideDashboardMenuAction.type]: (state: AppContainerWithMenuState) => {
    if (state.isDashboardMenuVisible) {
      appStorage.setAppMenuIsDashboardMenuVisible(state.isDashboardMenuVisible);
      appStorage.setAppMenuIsFullMenuVisible(state.isFullMenuVisible);
    }
  },
};
